<template>
  <div class="font-size-20">
    <div class="flex-column flex-center">
      <div class="font-size-22">
        <slot name="text"></slot>
      </div>
      <div v-if="toCancelSecond">
        请尽快支付对账单货款完成对账单结算
      </div>
      <div class="m-t-10">
        <slot name="btn"></slot>
      </div>
    </div>
    <div v-show="isScroll" class="flex flex-between flex-row-center pay-count-down-two">
      <div>
        <span class="m-r-20 font-size-22">
          <slot name="text"></slot>
        </span>
        <span v-if="toCancelSecond">
          请尽快支付对账单货款完成对账单结算
        </span>
      </div>
      <div class="btn-box">
        <slot name="btn"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PayCountdown",
  props: {
    timeValue: {
      type: Number
    },
    isScroll: {
      type: Boolean,
      default: false
    },
    toCancelSecond: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="less" scoped>
.pay-count-down-two {
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10;
  padding: 10px;
  position: fixed;
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  background-color: #ffffff;
}
.btn-box {
  margin-right: 30px;
}
</style>
